export const DEFAULT_DISABLED_BREADCRUMB_PATHS = ['/contractrequest/contract-request-details', '/contractrequest'];
